/**
 * createModelFromQuads() - Creates a p5.Geometry object from an array of Quad objects
 *
 * @param {Quad[]} quadsArray - Array of Quad objects
 * @param {string} geometryId - Unique ID necessary to cache and reuse the geometry
 * @returns {p5.Geometry} - p5.Geometry object
 */
export function createModelFromQuads(
  quadsArray,
  geometryId = "p5_geometry",
  verbose = false
) {
  return new p5.Geometry(
    1, // detailX (unused)
    1, // detailY (unused)
    function createGeometry() {
      let quadId = 0;
      for (let q of quadsArray) {
        if (verbose) console.log(`🔽 Quad ${quadId}`);

        let verts = q.getVertices();
        let uvs = q.getUVs();
        for (let i = 0; i < 4; i++) {
          let x = verts[i].x;
          let y = verts[i].y;
          let z = verts[i].z;
          this.vertices.push(createVector(x, y, z));

          let u = uvs[i].x;
          let v = uvs[i].y;
          this.uvs.push([u, v]);

          if (verbose) {
            console.log(`  ⬛ pos(${x},${y})`);
            console.log(`  ⬜ uv(~${u},~${v})`);
          }
        }
        let f = quadId * 4;
        this.faces.push([f + 0, f + 1, f + 3]);
        this.faces.push([f + 3, f + 1, f + 2]);
        quadId++;
      }
      this.gid = geometryId; // unique ID necessary to cache and reuse the geometry
    }
  );
}

export function createTestGeometry() {
  let sz = 100;
  return new p5.Geometry(1, 1, function createGeometry() {
    this.vertices.push(
      new p5.Vector(-sz, -sz, 0),
      new p5.Vector(sz, -sz, 0),
      new p5.Vector(-sz, sz, 0),
      new p5.Vector(sz, sz, 0)
    );
    this.uvs.push([0, 0], [0, 1], [1, 0], [1, 1]);
    this.computeFaces();
    this.computeNormals();
    this.gid = "my-square-geometry";
  });
}